import { render, staticRenderFns } from "./CurrentAgePercentageChart.vue?vue&type=template&id=6d83cd7b"
import script from "./CurrentAgePercentageChart.vue?vue&type=script&lang=ts"
export * from "./CurrentAgePercentageChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports